import { render, staticRenderFns } from "./RoundDownload.vue?vue&type=template&id=bb3ddb10&scoped=true&"
import script from "./RoundDownload.vue?vue&type=script&lang=js&"
export * from "./RoundDownload.vue?vue&type=script&lang=js&"
import style0 from "./RoundDownload.vue?vue&type=style&index=0&id=bb3ddb10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3ddb10",
  null
  
)

export default component.exports